import styled from "styled-components";
import { getDeviceType, getTheme, themed, Flow, Text as Tx, } from "@bracket/ui";
import type { Asset, } from "@bracket/types";
import { PanelItem, } from "@bracket/platform/components";
import { formatDollars, formatWEI, } from "@formatters";
import { useMemo } from "react";




export declare type ValueCardProps = {
	label: string;
	value: number | string;
	denomination?: Asset;
	tip?: string;
	showAsset?: boolean;
}




export const ValueCard = ({
	label,
	value,
	denomination,
	tip,
	showAsset = true,
}: ValueCardProps ) => {
	themed();

	const {
		symbol,
		decimals,
		label: denominationLabel,
	} = denomination || {};

	const value_formatted = useMemo(() => {
		if(typeof value === "number") {
			return new Intl.NumberFormat("en-US", { maximumFractionDigits: 5, minimumFractionDigits: 5, }).format(value);
		}
		return value;
	}, [value]);

	return (
		<PanelItem color="surface_variant_on" label={label} tip={tip}>
			<ValueGroup>
			{ getDeviceType() === "MOBILE" ? (
				<Tx xl>{value_formatted.toString()}</Tx>
			) : (
				<Tx h6>{value_formatted.toString()}</Tx>
			)}
			</ValueGroup>
		</PanelItem>
	);

}



const ValueGroup = styled(Flow)`
	span {
		&.percent {
			padding-left: 1rem;
			color: ${() => getTheme().surface_variant_on};
			font-size: 1rem;
		}
	}
	> p {
		padding-top: .25rem;
		&.brkt-value {
			padding-top: 0;
		}
		&.perc-value {
			position: absolute;
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			font-size: 1.5rem;
			right: 1rem;
		}
	}
`;
